import URL from 'url'

const apiError = (status, message) => {
  const err = new Error(message);
  err.status = status;
  return err;
}

const isNotSuccess = status => status !== 200;
const isNotUnAuthorised = status => status !== 403;

const filterAPIError = res => {
  if (isNotSuccess(res.status) && isNotUnAuthorised(res.status) ) {
    return res.json().then(data => {
      throw apiError(res.status, data.error)
    })
  }
  return res;
}

export default (code, state, publicApiUri) => {
  const request = URL.parse(`${publicApiUri}/authorize`);
  request.query = { code, state };

  return fetch(request.format(), {credentials: 'include'})
    .then(filterAPIError)
}



// WEBPACK FOOTER //
// ./src/app/helpers/establishSession.js